import { render, staticRenderFns } from "./Plataformas.vue?vue&type=template&id=139d0f0e&scoped=true"
import script from "./Plataformas.vue?vue&type=script&lang=js"
export * from "./Plataformas.vue?vue&type=script&lang=js"
import style0 from "./Plataformas.vue?vue&type=style&index=0&id=139d0f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d0f0e",
  null
  
)

export default component.exports